<template>
    <div class="">
        <b-row class="mb-2">
            <b-col v-if="widgetMode.mode=='view'" cols="12" class="p-0 d-flex align-items-end">
                <b-button class="border-0 bg-transparent ml-auto" size="sm" v-on:click="toggleWidgetMode()">
                    <b-icon icon="pencil-square" scale="2" variant="warning"> </b-icon>
                </b-button>
            </b-col>
            <b-col v-else cols="12" class="p-0">
                <b-form-select id='widgetlist' v-model="selectedWidget" size="sm" @change="widgetSelectChanged()" class="w-25 mr-1" :options="availableWidgets" placeholder='Select a widget'></b-form-select>
                <b-button id="add" class="e-warning m-1" size="sm" v-on:click="addWidget" :variant="selectedWidget!=null && widgetSelectionChanged==true ? 'success' : 'secondary'">Add Widget</b-button>
                <b-button id="view" class="e-warning m-1" size="sm" v-on:click="toggleWidgetMode()">Cancel</b-button>
                <b-button id="save" class="e-warning m-1" size="sm" v-on:click="saveDashboardLayout()" :variant="dashboardChanged==true ? 'success' : 'secondary'">Save</b-button>
            </b-col>
        </b-row>

        <b-row class="border ">
            <ejs-dashboardlayout id='myDashboard'
                                 ref="myDashboard"
                                 :cellSpacing="spacing"
                                 columns="12"
                                 :allowResizing="widgetMode.mode=='edit'"
                                 :allowDragging="widgetMode.mode=='edit'"
                                 :resizeStop="widgetResizeStop"
                                 :dragStop="widgetDragStop"
                                 :showGridLines="true"
                                 style="z-index: 500;">
                <!-- z-index fix to make sure the dashboard is not interfering with the logout dropw down menu -->
            </ejs-dashboardlayout>
        </b-row>
    </div>
</template>

<script>

    import Vue from "vue";
    // Import syncfusion dashboardlayout component from layouts package
    import { DashboardLayoutPlugin } from "@syncfusion/ej2-vue-layouts";
    import { DropDownListPlugin } from "@syncfusion/ej2-vue-dropdowns";
    import WidgetWrapper from "./WidgetWrapper.vue";
    import UuidMixins from '../../mixins/UuidMixins';
    import ErrorsMixin from '../../mixins/ErrorsMixin';
    import axios from 'axios';

    Vue.use(DashboardLayoutPlugin);
    Vue.use(DropDownListPlugin);

    export default {

        name: 'Dashboard',
        mixins: [ErrorsMixin, UuidMixins],
        props: {
            availableWidgets: {
                type: Array,
                required: true
            }
        },
        data: function () {
            return {
                spacing: [10, 10],
                widgetMode: { mode: 'view' },

                selectedWidget: null,
                myWidgets: [],
                dashboardChanged: false,
                widgetSelectionChanged: false,
                dashboardConfigurationId: null,
                dashboardConfiguration: null,
            };
        },

        methods: {

            widgetSelectChanged: function () {
                this.widgetSelectionChanged = true;
                //this.selectedWidget = null;
            },

            removeWidget: function (panelId) {
                var dashboardObj = this.$refs.myDashboard.$el.ej2_instances[0];
                // removing the panel from the dashboard ...
                dashboardObj.removePanel(panelId);
                // ... and removing it from the myWidgets array which is used for POST operation
                const objWithIdIndex = this.myWidgets.findIndex((obj) => obj.panelId === panelId);
                if (objWithIdIndex > -1) {
                    this.myWidgets.splice(objWithIdIndex, 1);
                    this.dashboardChanged = true;
                }
            },

            onConfigurationChanged: function (panelId, title, configuration) {
                var widgetObject = this.myWidgets.find(obj => obj.panelId === panelId);
                if (widgetObject) {
                    widgetObject.title = title;
                    widgetObject.configuration = configuration;
                    this.dashboardChanged = true;
                }
            },

            // handler for ADD widget button
            addWidget: function () {
                if (this.selectedWidget) {
                    var widgetObject = {};
                    widgetObject.widgetComponent = this.selectedWidget.componentName;
                    widgetObject.title = this.selectedWidget.defaultTitle;
                    widgetObject.panelId = this.newUuid();
                    widgetObject.row = 0;
                    widgetObject.col = 0;
                    widgetObject.sizeX = this.selectedWidget.defaultSizeX;
                    widgetObject.sizeY = this.selectedWidget.defaultSizeY;
                    if (this.selectedWidget.defaultConfiguration) widgetObject.configuration = this.selectedWidget.defaultConfiguration;
                    this.myWidgets.push(widgetObject);
                    this.addPanel(widgetObject, this.selectedWidget);
                    this.selectedWidget = null;
                } else {
                    this.$bvToast.toast('Please select a widget from drop down', {
                        title: 'WARNING',
                        variant: 'warning',
                        appendToast: true
                    });
                }
                this.widgetSelectionChanged = false;
                this.dashboardChanged = true;
            },

            // handler called from addWidget() function and for each widget after data has loaded
            addPanel: function (widgetObject, widgetOptions = null) {
                if (!widgetOptions) {
                    widgetOptions = this.availableWidgets.find(widget => widget.value.componentName == widgetObject.widgetComponent);
                    if (!widgetOptions) {
                        widgetOptions = {
                            minSizeX: 2,
                            minSizeY: 2,
                            maxSizeX: 4,
                            maxSizeY: 4
                        };
                    } else {
                        widgetOptions = widgetOptions.value;
                    }
                }
                var dashboardObj = this.$refs.myDashboard.$el.ej2_instances[0];
                var panel = {
                    'id': widgetObject.panelId,
                    'row': widgetObject.row,
                    'col': widgetObject.col,
                    'sizeX': widgetObject.sizeX,
                    'sizeY': widgetObject.sizeY,
                    'minSizeX': widgetOptions.minSizeX,
                    'minSizeY': widgetOptions.minSizeY,
                    'maxSizeX': widgetOptions.maxSizeX,
                    'maxSizeY': widgetOptions.maxSizeY,
                    'content': () => this.getPanelContent(widgetObject, widgetOptions)
                };
                dashboardObj.addPanel(panel);
            },

            getPanelContent: function (widgetObject, widgetOptions) {

                return {
                    template: WidgetWrapper,
                    data:
                    {
                        panelId: widgetObject.panelId,
                        dashboardWidgetConfigurationId: widgetObject.dashboardWidgetConfigurationId,
                        widgetComponent: widgetObject.widgetComponent,
                        widgetMode: this.widgetMode,
                        title: widgetObject.title,
                        supportsConfiguration: widgetOptions.supportsConfiguration,
                        supportedTimeRanges: widgetOptions.supportedTimeRanges,
                        selectedTimeRange: widgetOptions.defaultTimeRange ? widgetOptions.defaultTimeRange : widgetOptions.supportedTimeRanges ? widgetOptions.supportedTimeRanges[0].underlyingValue : null,
                        configuration: widgetObject.configuration,
                        onConfigurationChanged: this.onConfigurationChanged,
                        onRemoveWidget: this.removeWidget
                    }
                };
            },

            // Create
            saveDashboardLayout: function () {

                // Loop over all widgets in the myWidgest array, find their actual attribues, update myWidgets for post operation
                this.myWidgets.forEach((element) => {

                    var draggedWidget = document.getElementById(element.panelId);

                    element.row = draggedWidget.getAttribute('data-row');
                    element.col = draggedWidget.getAttribute('data-col');
                    element.sizeX = draggedWidget.getAttribute('data-sizex');
                    element.sizeY = draggedWidget.getAttribute('data-sizey');

                });

                var body = {
                    "name": "My Dashboard",
                    "description": "description of dashboard",
                    "isDefault": true,
                    "isShared": false,
                    "widgets": this.myWidgets
                }

                var url = this.$urlHelper.getApiUrl("dashboard", null, [this.dashboardConfigurationId]);

                axios
                    .put(url, JSON.stringify(body),
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                    .then(() => {
                        this.$bvToast.toast('Widgets saved', {
                            title: 'SUCCESS',
                            variant: 'success',
                            appendToast: true
                        });
                        this.dashboardChanged = false;
                        this.toggleWidgetMode();
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    });
            },

            createOrGetDetaultConfigurationId: function () {

                var url = this.$urlHelper.getApiUrl("dashboard", "dashboardconfigurations");
                return axios
                    .get(url)
                    .then(response => {
                        if ((response.data !== null) && (response.data.length > 0)) {
                            this.dashboardConfigurationId = response.data[0].dashboardConfigurationId;
                        } else {
                            var data = {
                                isDefault: true,
                                isShared: false
                            }
                            url = this.$urlHelper.getApiUrl("dashboard");
                            axios
                                .post(url, JSON.stringify(data),
                                    {
                                        headers: {
                                            'Content-Type': 'application/json'
                                        }
                                    })
                                .then(response => {
                                    this.dashboardConfigurationId = response.data;
                                })
                                .catch(ex => {
                                    var currentErrors = this.handleAxiosException(ex);
                                    this.showErrorsToast(currentErrors);
                                });
                        }
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    });
            },

            loadDashboardConfiguration: function () {
                var url = this.$urlHelper.getApiUrl("dashboard", "dashboardConfiguration");
                var componentNames = this.availableWidgets.map(aw => aw.value.componentName);
                var data = {
                    availableWidgets: componentNames,
                    dashboardConfigurationId: this.dashboardConfigurationId
                }
                axios
                    .put(url, JSON.stringify(data),
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                    .then(response => {
                        this.dashboardConfiguration = response.data;

                        this.$bvToast.toast('Widgets loaded', {
                            title: 'SUCCESS',
                            variant: 'success',
                            appendToast: true
                        });

                        var myWidgets = response.data.widgets;
                        this.myWidgets = [];
                        var dashboardObj = this.$refs.myDashboard.$el.ej2_instances[0];
                        dashboardObj.removeAll();

                        myWidgets.forEach((widgetObject) => {

                            widgetObject.panelId = this.newUuid();
                            this.myWidgets.push(widgetObject);
                            this.addPanel(widgetObject);
                        });

                    })
                    .catch(ex => {
                        this.currentErrors = this.handleAxiosException(ex);
                    });
            },

            toggleWidgetMode: function () {

                if (this.widgetMode.mode == 'view') {
                    this.widgetMode.mode = 'edit';
                } else {
                    this.widgetMode.mode = 'view';
                    this.widgetSelectionChanged = false;
                    this.loadDashboardConfiguration();
                }
            },

            widgetResizeStop: function () {
                this.dashboardChanged = true;
            },
            widgetDragStop: function () {
                this.dashboardChanged = true;
            }
        },

        mounted: function () {
            this.createOrGetDetaultConfigurationId()
                .then(() => {
                    this.loadDashboardConfiguration();
                });
        }
    }
</script>